import { Controller } from "react-hook-form";
import { commonFormProps } from "../../../utils/typeDefs";
import { DatePicker } from "rsuite";
import { convertDate } from "../../../utils/reusables";

const InputDatePicker = ({
  title,
  inputName,
  errors,
  control,
  inputErrorMessage,
  defaultInput,
  rules,
}: commonFormProps) => {
  const handleDateClick = () => {
    const datePickerElem: HTMLElement | null = document.querySelector(
      ".rs-picker-date-menu"
    );

    datePickerElem?.classList.remove("d-none");
  };

  return (
    <div className="row pb-2 form-input-field">
      <div className="col-12 col-md-3 my-auto">
        <p className="form-label">
          {title}: {errors && inputErrorMessage("Required")}
        </p>
      </div>
      <div className="col-12 col-md-9">
        <Controller
          name={inputName}
          control={control}
          rules={rules}
          render={({ field }) => {
            return (
              <DatePicker
                onClick={() => handleDateClick()}
                oneTap
                onChange={field.onChange}
                format="dd-MM-yyyy"
                value={
                  field.value && !String(field.value)?.startsWith("Invalid")
                    ? new Date(field.value)
                    : null
                }
                renderValue={(value) => {
                  if (value !== null) {
                    const newValue = convertDate(String(value));
                    return newValue;
                  } else return "";
                }}
                placeholder={"dd-MM-yyyy"}
              />
            );
          }}
          defaultValue={convertDate(defaultInput)}
        />
      </div>
    </div>
  );
};

export default InputDatePicker;
